import useLanguage from "../i18n/useLanguage";
import { useState, useEffect } from "react";
import { services as defaultServices } from "../data/services";
import { fetchServices } from "../api/client";
import "../App.css";

export default function Services() {
  const { t } = useLanguage();
  const [servicesList, setServicesList] = useState(defaultServices);
  const [active, setActive] = useState(0);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    let isMounted = true;
    fetchServices(defaultServices).then((data) => {
      if (isMounted && data && data.length > 0) {
        setServicesList(data);
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section id="services" className="min-h-screen bg-black text-white py-20">
      <div className="min-h-screen flex flex-col">
        {/* Title */}
        <div className="w-full flex justify-center mb-32 mt-4">
          <h2 className="text-6xl font-bold text-amber-300 text-center">{t("Our services")}{" "}</h2>
        </div>

        <div className="w-full flex justify-center -mt-20">
          <div className="w-full max-w-5xl px-6 flex flex-col gap-16 md:gap-24">
            {/* Intro */}
            <div className="max-w-2xl max-auto">
              <p className="text-2xl font-semibold mb-4">{t("Apapun yang kamu butuhin,")}{" "}
                <span className="relative inline-block">{t("we got it")}{" "}<span className="absolute left-0 -bottom-1 w-full h-0.5 bg-white rotate-[-4deg]" />
                  <span className="absolute left-1 -bottom-2 w-[90%] h-[1.5px] bg-white/70 rotate-3" />
                </span>
              </p>

              <p className="text-2xl font-normal text-gray-400 leading-snug max-w-4xl">{t("Dari coding sampe desain, semua bisa. Mix & match sesuka hati, atau ambil paket lengkap biar lebih worth it.")}{" "}</p>
            </div>

            {/* Cards */}
            <div className="flex gap-6 items-stretch overflow-x-auto scrollbar-hide snap-x snap-mandatory -mt-16">
              {servicesList.map((service, i) => {
                const isActive = active === i;
                const isHovered = hovered === i && !isActive;

                return (
                  <div
                    key={i}
                    onClick={() => setActive(i)}
                    onMouseEnter={() => setHovered(i)}
                    onMouseLeave={() => setHovered(null)}
                    className={`
                      relative flex flex-col justify-end cursor-pointer overflow-hidden
                      rounded-2xl border border-white/10
                      transition-all duration-700 ease-out
                      shrink-0 snap-start
                       ${
                         isActive
                           ? "w-[300px] sm:w-[380px] md:w-[460px]"
                           : "w-[180px] sm:w-[220px]"
                       }
                      min-h-[320px]
                      bg-black
                    `}
                  >
                    {/* Active gradient */}
                    <div
                      className={`absolute inset-0 transition-opacity duration-700 ${
                        isActive
                          ? "opacity-100 bg-gradient-to-br from-amber-400/40 via-amber-300/20 to-transparent"
                          : "opacity-0"
                      }`}
                    />

                    {/* Hover gradient */}
                    <div
                      className={`absolute inset-0 transition-opacity duration-300 ${
                        isHovered
                          ? "opacity-100 bg-gradient-to-br from-amber-400/20 via-amber-300/10 to-transparent"
                          : "opacity-0"
                      }`}
                    />

                    {/* Content */}
                    <div className="relative z-10 min-w-0 p-4 sm:p-6">
                      <h3 className="text-2xl md:text-3xl font-bold mb-3 text-left break-words leading-tight">
                        {t(service.title)}
                      </h3>

                      {isActive && (
                        <p className="text-gray-300 text-xs md:text-sm font-normal leading-relaxed">
                          {t(service.desc)}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
